module.exports = __webpack_public_path__ + "monte-everest.efdd02700409f04c0b68c4dca0d38348.jpg";